import styled from 'styled-components';

import { BackgroundColor, Margin, MaximumPageWidth } from '../styles';

export const DSPageLayoutStyled = styled.div`
  background-color: ${BackgroundColor.BaseWhite};
  margin: ${Margin.None} auto ${Margin.Base} auto;
  max-width: ${MaximumPageWidth.SingleContentBlock};
  padding: 16.5rem 4rem 4rem 4rem;
         
  @media (min-width: 1450px) {
   padding-top: 18.5rem;
  }
         @media (min-width: 2000px) {
   padding-top: 20.5rem;
  }
            @media (min-width: 2250px) {
   padding-top: 23.5rem;
  }

  @media (max-width: 82rem) {
    margin: ${Margin.None} ${Margin.Base} ${Margin.Base} ${Margin.Base};
  }

  h2 {
    margin-top: ${Margin.Base};
  }
`;
